import * as t from './actionTypes';
import { AppPlatform, Integration, IntegrationType, MobileApp, TestPushPayload } from './types';

// FETCH MOBILE APP
export const fetchMobileApp = (id: number) => ({
  type: t.FETCH_MOBILE_APP_REQUEST,
  id,
});

export const fetchMobileAppResponse = (mobileAppInfo: MobileApp) => ({
  type: t.FETCH_MOBILE_APP_RESPONSE,
  mobileAppInfo,
});

export const fetchMobileAppError = (error: string) => ({
  type: t.FETCH_MOBILE_APP_ERROR,
  error,
});

// FETCH MOBILE APPS
export const fetchMobileApps = () => ({
  type: t.FETCH_MOBILE_APPS_REQUEST,
});

export const fetchMobileAppsResponse = (mobileApps: Record<number, MobileApp>) => ({
  type: t.FETCH_MOBILE_APPS_RESPONSE,
  mobileApps,
});

// CREATE MOBILE APP
export const createMobileApp = (
  mobileApp: Pick<MobileApp, 'name' | 'packageName' | 'storeUrl'> & {
    platform?: AppPlatform;
  },
) => ({
  type: t.CREATE_MOBILE_APP_REQUEST,
  mobileApp,
});

export const createMobileAppResponse = (mobileApps: MobileApp[]) => ({
  type: t.CREATE_MOBILE_APP_RESPONSE,
  mobileApps,
});

// UPDATE MOBILE APP
export const updateMobileApp = (mobileApp: MobileApp) => ({
  type: t.UPDATE_MOBILE_APP_REQUEST,
  mobileApp,
});

export const updateMobileAppResponse = (mobileApps: MobileApp[]) => ({
  type: t.UPDATE_MOBILE_APP_RESPONSE,
  mobileApps,
});

// DELETE MOBILE APP
export const deleteMobileApp = (mobileApp?: MobileApp) => ({
  type: t.DELETE_MOBILE_APP_REQUEST,
  mobileApp,
});

export const deleteMobileAppResponse = () => ({
  type: t.DELETE_MOBILE_APP_RESPONSE,
});

// FETCH INTEGRATIONS
export const fetchIntegrations = () => ({
  type: t.FETCH_INTEGRATIONS_REQUEST,
});

export const fetchIntegrationsResponse = (integrations: Record<number, IntegrationType>) => ({
  type: t.FETCH_INTEGRATIONS_RESPONSE,
  integrations,
});

export const fetchIntegrationsError = () => ({
  type: t.FETCH_INTEGRATIONS_ERROR,
});

// CREATE INTEGRATION
export const createIntegration = (integration: Integration) => ({
  type: t.CREATE_INTEGRATION_REQUEST,
  integration,
});

export const createIntegrationResponse = (integrations: Record<number, IntegrationType>) => ({
  type: t.CREATE_INTEGRATION_RESPONSE,
  integrations,
});

export const createIntegrationError = () => ({
  type: t.CREATE_INTEGRATION_ERROR,
});

// ASSIGN INTEGRATION
export const assignIntegration = (integration: Integration) => ({
  type: t.ASSIGN_INTEGRATION_REQUEST,
  integration,
});

export const assignIntegrationResponse = (integrations: IntegrationType) => ({
  type: t.ASSIGN_INTEGRATION_RESPONSE,
  integrations,
});

export const assignIntegrationError = () => ({
  type: t.ASSIGN_INTEGRATION_ERROR,
});

// UPDATE INTEGRATION
export const updateIntegration = (integration: Integration) => ({
  type: t.UPDATE_INTEGRATION_REQUEST,
  integration,
});

export const updateIntegrationResponse = (integrations: Record<number, IntegrationType>) => ({
  type: t.UPDATE_INTEGRATION_RESPONSE,
  integrations,
});

export const updateIntegrationError = () => ({
  type: t.UPDATE_INTEGRATION_ERROR,
});

// DELETE INTEGRATION
export const deleteIntegration = (integration: Integration) => ({
  type: t.DELETE_INTEGRATION_REQUEST,
  integration,
});

export const deleteIntegrationResponse = (integrations: IntegrationType) => ({
  type: t.DELETE_INTEGRATION_RESPONSE,
  integrations,
});

export const deleteIntegrationError = () => ({
  type: t.DELETE_INTEGRATION_ERROR,
});

// SEND TEST PUSH
export const sendTestPush = (pushMessage: TestPushPayload) => ({
  type: t.SEND_TEST_PUSH_REQUEST,
  pushMessage,
});

export const sendTestPushResponse = () => ({
  type: t.SEND_TEST_PUSH_RESPONSE,
});

export const sendTestPushError = () => ({
  type: t.SEND_TEST_PUSH_ERROR,
});
